import { useTranslation } from 'react-i18next';
import { NavLink, Outlet } from 'react-router';
import styles from './SideMenuPageLayout.module.css';

export interface PageSection {
  // Navigation target — absolute (e.g. /locations/:id/settings/patients) or
  // relative to the layout route (e.g. room-bookings).
  to: string;
  labelKey: string;
}

export interface PageSectionGroup {
  // Optional group heading shown above the sections.
  labelKey?: string;
  sections: PageSection[];
}

interface SideMenuPageLayoutProps {
  headingKey: string;
  groups: readonly PageSectionGroup[];
}

export const SideMenuPageLayout = ({ headingKey, groups }: SideMenuPageLayoutProps) => {
  const { t } = useTranslation();

  return (
    <main className={styles.page}>
      <h1 className={styles.heading}>{t(headingKey)}</h1>
      <div className={styles.content}>
        <nav className={styles.sideMenu}>
          {groups.map((group, groupIndex) => (
            <div key={group.labelKey ?? `group-${groupIndex}`} className={styles.group}>
              {group.labelKey && <p className={styles.groupHeading}>{t(group.labelKey)}</p>}
              {group.sections.map((section) => (
                <NavLink
                  key={section.to}
                  to={section.to}
                  end
                  className={({ isActive }) =>
                    `${styles.menuItem} ${isActive ? styles.menuItemActive : ''}`
                  }
                >
                  {t(section.labelKey)}
                </NavLink>
              ))}
            </div>
          ))}
        </nav>
        <div className={styles.subPage}>
          <Outlet />
        </div>
      </div>
    </main>
  );
};
